@if (client() || restrictedClient()) {
	@if (!editModeFromRoute()) {
		<lvr-heading [showEditButton]="canEdit() && !!client()" (editClicked)="setEditMode()">
			@let firstName = client()?.firstName ?? restrictedClient()?.firstName;
			{{ 'client.client_details.title' | transloco }}
			{{ client()?.name ?? restrictedClient()?.name }}{{ firstName ? ', ' + firstName : '' }}

			@if (client()?.dateOfBirth || restrictedClient()?.dateOfBirth) {
				*{{ client()?.dateOfBirth ?? restrictedClient()?.dateOfBirth | date: dateDisplayFormat }}
			}

			@if (canEdit() && client()) {
				<div ngProjectAs="button-content">
					<lvr-button
						variant="primary"
						[label]="'base.button.export' | transloco"
						[ariaLabel]="'base.button.export_pdf' | transloco"
						[loadingLabel]="'base.button.generating_pdf' | transloco"
						[loading]="isExportLoading()"
						[type]="'button'"
						(clicked)="export()"
						icon="ios_share"
					></lvr-button>
				</div>
			}
			@if (restrictedClient()) {
				<div ngProjectAs="button-content">
					<lvr-button
						variant="primary"
						[label]="'base.button.request' | transloco"
						[ariaLabel]="'base.button.request_aria_label' | transloco"
						[type]="'button'"
						(clicked)="request()"
						icon="assignment_add"
					></lvr-button>
				</div>
			}
		</lvr-heading>

		@if (restrictedClient()) {
			<lvr-client-restricted-details-view [client]="restrictedClient()"></lvr-client-restricted-details-view>
		} @else if (client()) {
			<lvr-client-details-view [counties]="counties()" [client]="client()" />
		}
	}

	@if (editModeFromRoute() && client()) {
		<lvr-client-details-edit
			[client]="client()"
			(cancelEdit)="handleCancel()"
			(save)="handleSave($event)"
			[isSaving]="isSaving()"
		/>
	}
}
